<template>
  <div>
    <div class="application13">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <img src="../../assets/images/application/application13-1.jpg" alt />
          <img src="../../assets/images/application/application13-2.jpg" alt />
        </div>
      </module1>
    </div>
    <div class="mobile-application13">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item v-for=" index in 2" :key="index">
              <img :src="getImg(`application13-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application13",
  metaInfo: {
    title:
      "智慧化工厂可视化系统_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "智慧化工厂,三维化工厂,化工厂可视化,化工厂三维建模渲染"
      },
      {
        name: "description",
        content:
          "基于三维GIS、BIM、VR技术,对化工厂区进行三维建模,对重点设备设施重大危险源等进行BIM数据可视化,结合园区视频监控和告警传感信息,为化工园区建立全景和细部三维可视化管理视图,建立园区预案和应急响应辅助决策系统,实现化工园区扁平化、高效率监控管理。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧化工厂可视化系统",
        p:
          "基于三维GIS、BIM、VR技术，对化工厂区进行三维建模，对重点设备设施重大危险源等进行BIM数据可视化，结合园区视频监控和告警传感信息，为化工园区建立全景和细部三……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "化工园区、化工类公司、安监局等化工安全生产应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "基于三维GIS、BIM、VR技术，对化工厂区进行三维建模，对重点设备设施重大危险源等进行BIM数据可视化，结合园区视频监控和告警传感信息，为化工园区建立全景和细部三维可视化管理视图，建立园区预案和应急响应辅助决策系统，实现化工园区扁平化、高效率监控管理。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application13 {
  font-size: 0;
  img {
    width: 584px;
    margin-top: 20px;
    &:nth-child(2n + 1) {
      margin-right: 20px;
    }
  }
}
.mobile-application13 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application13 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application13 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application13.vue